import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './greeting.module.scss';
import {
  Heading1,
  SubTitle,
  SmallText,
  Button,
} from '../../../../landingComponents/typography';
import LandingButton from '../../../../landingComponents/button';
import doctor from 'src/assets/img/landing/femaleDoctor.png';
import doctorCircle from 'src/assets/img/landing/doctorCircle.svg';
import { Helmet } from 'react-helmet-async';

const Greeting = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Left />
      <Right />
    </CommonLandingContainer>
  );
};

export default Greeting;

const Left = () => {
  return (
    <div className={styles.left}>
      <div>
        <Heading1 accent>Доктор,</Heading1>
        <Heading1 accent> что со мной?</Heading1>
      </div>
      <SubTitle>{`Разберем и объясним
       результаты ваших анализов*`}</SubTitle>
      <div>
        <div className={styles.buttons}>
          <LandingButton variant="contained" href="/questions">
            <Button>Проверить анализы</Button>
          </LandingButton>
          <LandingButton variant="outlined" href="/about">
            <Button>Как это работает?</Button>
          </LandingButton>
        </div>
      </div>
      <div className={styles.legendText}>
        <SmallText>
          {`*для анализа используются оцифрованные клинические рекомендации Минздрава РФ, а также другие документы, указанные в них`}
        </SmallText>
      </div>
    </div>
  );
};

const Right = () => {
  return (
    <>
      <Helmet>
        <link rel="preload" href={doctor} as="image" />
      </Helmet>
      <div className={styles.right}>
        <div className={styles.imageContainer}>
          <img
            fetchpriority="high"
            className={styles.doctor}
            src={doctor}
            alt="Ламетри - помощник"
          />
          <img
            className={styles.doctorCircle}
            src={doctorCircle}
            alt="Медицинские маркеры"
          />
        </div>
      </div>
    </>
  );
};
